import { useState } from 'react';

import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { refreshToken } from '@realadvisor/auth-client';
import { Globe } from 'lucide-react';

import type { LanguageMenuUpdateUserMutation } from '@graphql/__generated__/graphql';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { useLocale } from '@shared/hooks/locale';
import { languageMenuOptions } from '@shared/LocaleContext';

export const LanguageMenu = () => {
  const { t, language } = useLocale();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { me } = useAppData();
  const [updateUser] = useMutation<LanguageMenuUpdateUserMutation>(
    gql`
      mutation LanguageMenuUpdateUser($id: uuid!, $language: user_language!) {
        update_users_by_pk(
          pk_columns: { id: $id }
          _set: { language: $language }
        ) {
          id
          language
        }
      }
    `,
  );
  const changeLanguage = (newLanguage: String) => {
    if (language !== newLanguage) {
      updateUser({
        variables: {
          id: me?.id,
          language: newLanguage,
        },
        onCompleted: () => refreshToken().then(() => window.location.reload()),
      });
    }
  };
  return (
    <>
      <IconButton
        style={{ flexShrink: 0, margin: 4 }}
        title={t('Language')}
        onClick={handleClick}
        color="inherit"
      >
        <Globe size={22} strokeWidth={1.8} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {languageMenuOptions.map(option => (
          <MenuItem
            key={option.value}
            onClick={() => changeLanguage(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
